var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 7.33333C11.56 7.33333 11.78 7.36 12 7.39333V4.18L7 2L2 4.18V7.45333C2 10.48 4.13333 13.3133 7 14C7.36667 13.9133 7.72 13.7867 8.06667 13.6333C7.60667 12.98 7.33333 12.1867 7.33333 11.3333C7.33333 9.12667 9.12667 7.33333 11.3333 7.33333Z",
    fill: "#2B59A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 8.66663C9.85984 8.66663 8.6665 9.85996 8.6665 11.3333C8.6665 12.8066 9.85984 14 11.3332 14C12.8065 14 13.9998 12.8066 13.9998 11.3333C13.9998 9.85996 12.8065 8.66663 11.3332 8.66663ZM11.3332 9.58663C11.7465 9.58663 12.0798 9.92663 12.0798 10.3333C12.0798 10.74 11.7398 11.08 11.3332 11.08C10.9265 11.08 10.5865 10.74 10.5865 10.3333C10.5865 9.92663 10.9198 9.58663 11.3332 9.58663ZM11.3332 13.1666C10.7132 13.1666 10.1732 12.86 9.83984 12.3866C9.87317 11.9066 10.8465 11.6666 11.3332 11.6666C11.8198 11.6666 12.7932 11.9066 12.8265 12.3866C12.4932 12.86 11.9532 13.1666 11.3332 13.1666Z",
    fill: "#2B59A3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.e0efba90.svg";
export { ForwardRef as ReactComponent };